module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-0ZY33KY82N"],"pluginConfig":{"head":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"aditya.mudgil","short_name":"am2505","description":"Portfolio - Aditya Mudgil","start_url":"/","lang":"en","background_color":"#f7f0eb","theme_color":"#d24d57","display":"standalone","icon":"src/images/extra/Icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"307e52b0310f6d1a75832f7ca347ce1f"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/","/404","/projects/*","/contact","/about"]},
    }]
